import { IFormResponseDetail, IFormResponseRes } from '../interfaces/form-response.interface';
import { FormResponseDto } from './form-response.dto';

export class FormResponseDetailDto extends FormResponseDto implements IFormResponseDetail {
  responses!: IFormResponseRes[];
}
